/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ZerogHomeTotalTrxCountInfo = {
    TRXTP: ZerogHomeTotalTrxCountInfo.TRXTP;
    TTRXCNT: string;
};

export namespace ZerogHomeTotalTrxCountInfo {

    export enum TRXTP {
        NORMAL = 'NORMAL',
        INTERNAL = 'INTERNAL',
        PENDING = 'PENDING',
    }


}

